import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import {Helmet} from "react-helmet";

class TankView extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
	  tankId: this.props.location.data ? this.props.location.data : this.props.location.state.data ? this.props.location.state.data : 0,
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      tankData: [],
      iotHistoryData: [],
      iotlevelData: [],
      test: [],
	  deviceId: "",
	  capacity: "",
	  type: "",
	  shape: "",
	  height: "",
	  length: "",
	  width: "",
    };
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
	  
	let postUserData = {
		tankId: this.state.tankId
	};
	if(this.props.userRole === "Project Engineer"){
	fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getiotdetailscomplete', {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		},
			body: JSON.stringify(postUserData)
		}).then((response) => {
			if (response.status === 400) {
			  this.setState({ throwUserError: true })
			} else { return response.json() }
		}).then((data) => {
			console.log(data)
			this.setState({ iotHistoryData: data.iothistorydata })
		}).catch((error) => console.log(error))
	}else{
	fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getiotdetails', {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
		},
			body: JSON.stringify(postUserData)
		}).then((response) => {
			if (response.status === 400) {
			  this.setState({ throwUserError: true })
			} else { return response.json() }
		}).then((data) => {
			console.log(data)
			this.setState({ iotHistoryData: data.iothistorydata })
		}).catch((error) => console.log(error))
	}
	
	
	fetch(process.env.REACT_APP_NODE_ENV + '/api/iot/getiottankdetails', {
	method: 'POST',
	headers: {
	  'Content-Type': 'application/json',
	  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
	},
		body: JSON.stringify(postUserData)
	}).then((response) => {
		if (response.status === 400) {
		  this.setState({ throwUserError: true })
		} else { return response.json() }
	}).then((data) => {
		console.log(data)
		this.setState({ tankData: data.tankdata })
		this.setState({ iotlevelData: data.iotleveldata })
	}).catch((error) => console.log(error))
		
  }


  render() {

    let dataArr = [];
    this.state.iotHistoryData.map((data) => {
		if(this.state.tankData.propertyId === "Ultrasonic")
		{
			let mdData = [
				data.id, data.iot_device_id, data.level, data.iot_curent_time, data.result
			];
			dataArr.push(mdData)
			return null;
		}else{
			let mdData = [
				data.id, data.device_id, data.lower_kl, data.higher_kl, data.iot_curent_time, data.result
			];
			dataArr.push(mdData)
			return null;
		}
    });
	
	const mystyle = {
	  marginRight: "5px"
    };
	const leveldev = {
	    backgroundColor: "white",
		padding: "10px"
	};
	const leveldevheadercolor = {
	    color: "red"
	};
	
	const wrapper = {
		backgroundColor: "#2d4e5a",
		height: "200px",
		width: "200px",
		position: "relative"
	}

    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "device_id",
        label: "Device Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "lower_kl",
        label: "Lower KL",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "higher_kl",
        label: "Higher KL",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "iot_curent_time",
        label: "Created",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "result",
        label: "result",
        options: {
          filter: true,
          sort: true,
		  display: false,
        }
      }
    ];
	
	const columns_ultrasonic = [
	  {
		name: "id",
		label: "Id",
		options: {
		  filter: true,
		  sort: true,
		}
	  },
	  {
		name: "device_id",
		label: "Device Id",
		options: {
		  filter: true,
		  sort: true,
		}
	  },
	  {
		name: "lower_kl",
		label: "Level",
		options: {
		  filter: true,
		  sort: true,
		}
	  },
	  {
		name: "iot_curent_time",
		label: "Created",
		options: {
		  filter: true,
		  sort: true,
		}
	  },
	  {
        name: "result",
        label: "result",
        options: {
          filter: true,
          sort: true,
		  display: false,
        }
      }
	];


    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none", viewColumns: false,
      downloadOptions: {
        filename: 'Iot List.csv',
      },
    };

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "Project Engineer") {
		if(this.state.tankData.propertyId === "Ultrasonic")
		{
			return (
			<>
			  <Breadcrumb>
				<Breadcrumb.Item active>View IoT</Breadcrumb.Item>
			  </Breadcrumb>

			<div style={{display: this.state.iotlevelData.lower_kl ? 'block' : 'none' },leveldev}>
				<div class="row">
					<div class="col-lg-7">
						<div class="row">
							<div style={{fontWeight: "900", color: "rgb(0 0 128)", fontSize: "30px", width: "100%", marginLeft: "10px", marginBottom: "30px"}}>Device Id: #{ this.state.tankData.deviceId }</div>
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(0 5 8)", width: "100%", fontSize: "25px" }}>TANK DETAILS</div>
						</div>
						<div class="row">
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(97, 111, 119)", fontSize: "16px", marginTop: "12px", marginLeft: "40px" }}>
								<div>
									<strong>Capacity : </strong>{ this.state.tankData.tankCapacity }<br />
									<strong>Type : </strong>{ this.state.tankData.tankType }<br />
									<strong>Shape : </strong>{ this.state.tankData.tankShapeDimension }<br />
									<strong>Height : </strong>{ this.state.tankData.tankHeight }<br />
									<strong>Length : </strong>{ this.state.tankData.tankLength }<br />
									<strong>Width : </strong>{ this.state.tankData.tankWidth }<br />
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-5">
						<iframe src={'https://www.gowatr.com/waterlevel.html?fillvalue='+ this.state.iotlevelData.lower_feet +'&klvalue='+ this.state.iotlevelData.lower_kl +'&name1='+ this.state.tankData.sensors1 +'&value1='+ this.state.tankData.feetLevel1 +'&typ1='+ this.state.tankData.description1 +'&name2='+ this.state.tankData.sensors2 +'&value2='+ this.state.tankData.feetLevel2 +'&typ2='+ this.state.tankData.description2 +'&name3='+ this.state.tankData.sensors3 +'&value3='+ this.state.tankData.feetLevel3 +'&typ3='+ this.state.tankData.description3 +'&name4='+ this.state.tankData.sensors4 +'&value4='+ this.state.tankData.feetLevel4 +'&typ4='+ this.state.tankData.description4 +'&name5='+ this.state.tankData.sensors5 +'&value5='+ this.state.tankData.feetLevel5 +'&typ5='+ this.state.tankData.description5 +'&name6=Start&value6=0&typ6=High&sensortype='+ this.state.tankData.propertyId} width="335" height="315" frameBorder="0" scrolling="no"></iframe>
					</div>
				</div>
			</div>

			  <div style={{ marginTop: "10px" }}>
				<Button className="float-right"
				  variant="outline-success"
				  style={{ marginTop: "10px", marginRight: "10px", width: "200px" }}
				  onClick={() => this.nextPath("/water-tank/tank-edit",this.state.tankId)
				  }>
				  Edit
			</Button>
				<MUIDataTable
				  title={"IoT List"}
				  data={dataArr}
				  columns={columns_ultrasonic}
				  options={options} />

			  </div>
			</>
			);
		}else{
			return (
			<>
			  <Breadcrumb>
				<Breadcrumb.Item active>View IoT</Breadcrumb.Item>
			  </Breadcrumb>

			<div style={{display: this.state.iotlevelData.lower_kl ? 'block' : 'none' },leveldev}>
				<div class="row">
					<div class="col-lg-7">
						<div class="row">
							<div style={{fontWeight: "900", color: "rgb(0 0 128)", fontSize: "30px", width: "100%", marginLeft: "10px", marginBottom: "30px"}}>Device Id: #{ this.state.tankData.deviceId }</div>
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(0 5 8)", width: "100%", fontSize: "25px" }}>TANK DETAILS</div>
						</div>
						<div class="row">
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(97, 111, 119)", fontSize: "16px", marginTop: "12px", marginLeft: "40px" }}>
								<div>
									<strong>Capacity : </strong>{ this.state.tankData.tankCapacity }<br />
									<strong>Type : </strong>{ this.state.tankData.tankType }<br />
									<strong>Shape : </strong>{ this.state.tankData.tankShapeDimension }<br />
									<strong>Height : </strong>{ this.state.tankData.tankHeight }<br />
									<strong>Length : </strong>{ this.state.tankData.tankLength }<br />
									<strong>Width : </strong>{ this.state.tankData.tankWidth }<br />
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-5">
						<iframe src={'https://www.gowatr.com/waterlevel.html?fillvalue='+ this.state.iotlevelData.lower_feet +'&klvalue='+ this.state.iotlevelData.lower_kl +'&name1='+ this.state.tankData.sensors1 +'&value1='+ this.state.tankData.feetLevel1 +'&typ1='+ this.state.tankData.description1 +'&name2='+ this.state.tankData.sensors2 +'&value2='+ this.state.tankData.feetLevel2 +'&typ2='+ this.state.tankData.description2 +'&name3='+ this.state.tankData.sensors3 +'&value3='+ this.state.tankData.feetLevel3 +'&typ3='+ this.state.tankData.description3 +'&name4='+ this.state.tankData.sensors4 +'&value4='+ this.state.tankData.feetLevel4 +'&typ4='+ this.state.tankData.description4 +'&name5='+ this.state.tankData.sensors5 +'&value5='+ this.state.tankData.feetLevel5 +'&typ5='+ this.state.tankData.description5 +'&name6=Start&value6=0&typ6=High&sensortype='+ this.state.tankData.propertyId} width="335" height="315" frameBorder="0" scrolling="no"></iframe>
					</div>
				</div>
			</div>

			  <div style={{ marginTop: "10px" }}>
				<Button className="float-right"
				  variant="outline-success"
				  style={{ marginTop: "10px", marginRight: "10px", width: "200px" }}
				  onClick={() => this.nextPath("/water-tank/tank-edit",this.state.tankId)
				  }>
				  Edit
			</Button>
				<MUIDataTable
				  title={"IoT List"}
				  data={dataArr}
				  columns={columns}
				  options={options} />

			  </div>
			</>
			);
		}
    } else {
		if(this.state.tankData.propertyId === "Ultrasonic")
		{
		  return (
			<>
			  <Breadcrumb>
				<Breadcrumb.Item active>View IoT</Breadcrumb.Item>
			  </Breadcrumb>
			  
			<div style={{display: this.state.iotlevelData.lower_kl ? 'block' : 'none' },leveldev}>
				<div class="row">
					<div class="col-lg-7">
						<div class="row">
							<div style={{fontWeight: "900", color: "rgb(0 0 128)", fontSize: "30px", width: "100%", marginLeft: "10px", marginBottom: "30px"}}>Device Id: #{ this.state.tankData.deviceId }</div>
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(0 5 8)", width: "100%", fontSize: "25px" }}>TANK DETAILS</div>
						</div>
						<div class="row">
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(97, 111, 119)", fontSize: "16px", marginTop: "12px", marginLeft: "40px" }}>
								<div>
									<strong>Capacity : </strong>{ this.state.tankData.tankCapacity }<br />
									<strong>Type : </strong>{ this.state.tankData.tankType }<br />
									<strong>Shape : </strong>{ this.state.tankData.tankShapeDimension }<br />
									<strong>Height : </strong>{ this.state.tankData.tankHeight }<br />
									<strong>Length : </strong>{ this.state.tankData.tankLength }<br />
									<strong>Width : </strong>{ this.state.tankData.tankWidth }<br />
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-5">
						<iframe src={'https://www.gowatr.com/waterlevel.html?fillvalue='+ this.state.iotlevelData.lower_feet +'&klvalue='+ this.state.iotlevelData.lower_kl +'&name1='+ this.state.tankData.sensors1 +'&value1='+ this.state.tankData.feetLevel1 +'&typ1='+ this.state.tankData.description1 +'&name2='+ this.state.tankData.sensors2 +'&value2='+ this.state.tankData.feetLevel2 +'&typ2='+ this.state.tankData.description2 +'&name3='+ this.state.tankData.sensors3 +'&value3='+ this.state.tankData.feetLevel3 +'&typ3='+ this.state.tankData.description3 +'&name4='+ this.state.tankData.sensors4 +'&value4='+ this.state.tankData.feetLevel4 +'&typ4='+ this.state.tankData.description4 +'&name5='+ this.state.tankData.sensors5 +'&value5='+ this.state.tankData.feetLevel5 +'&typ5='+ this.state.tankData.description5 +'&name6=Start&value6=0&typ6=High&sensortype='+ this.state.tankData.propertyId} width="335" height="315" frameBorder="0" scrolling="no"></iframe>
					</div>
				</div>
			</div>
			
			  <div style={{ marginTop: "10px" }}>
				
				<MUIDataTable
				  title={"IoT List"}
				  data={dataArr}
				  columns={columns_ultrasonic}
				  options={options} />

			  </div>
			</>
		  );
		}else{
			return (
			<>
			  <Breadcrumb>
				<Breadcrumb.Item active>View IoT</Breadcrumb.Item>
			  </Breadcrumb>
			  
			<div style={{display: this.state.iotlevelData.lower_kl ? 'block' : 'none' },leveldev}>
				<div class="row">
					<div class="col-lg-7">
						<div class="row">
							<div style={{fontWeight: "900", color: "rgb(0 0 128)", fontSize: "30px", width: "100%", marginLeft: "10px", marginBottom: "30px"}}>Device Id: #{ this.state.tankData.deviceId }</div>
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(0 5 8)", width: "100%", fontSize: "25px" }}>TANK DETAILS</div>
						</div>
						<div class="row">
							<div class="col" style={{fontWeight: "700", fontFamily: "Dosis, Arial, sans-serif", color: "rgb(97, 111, 119)", fontSize: "16px", marginTop: "12px", marginLeft: "40px" }}>
								<div>
									<strong>Capacity : </strong>{ this.state.tankData.tankCapacity }<br />
									<strong>Type : </strong>{ this.state.tankData.tankType }<br />
									<strong>Shape : </strong>{ this.state.tankData.tankShapeDimension }<br />
									<strong>Height : </strong>{ this.state.tankData.tankHeight }<br />
									<strong>Length : </strong>{ this.state.tankData.tankLength }<br />
									<strong>Width : </strong>{ this.state.tankData.tankWidth }<br />
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-5">
						<iframe src={'https://www.gowatr.com/waterlevel.html?fillvalue='+ this.state.iotlevelData.lower_feet +'&klvalue='+ this.state.iotlevelData.lower_kl +'&name1='+ this.state.tankData.sensors1 +'&value1='+ this.state.tankData.feetLevel1 +'&typ1='+ this.state.tankData.description1 +'&name2='+ this.state.tankData.sensors2 +'&value2='+ this.state.tankData.feetLevel2 +'&typ2='+ this.state.tankData.description2 +'&name3='+ this.state.tankData.sensors3 +'&value3='+ this.state.tankData.feetLevel3 +'&typ3='+ this.state.tankData.description3 +'&name4='+ this.state.tankData.sensors4 +'&value4='+ this.state.tankData.feetLevel4 +'&typ4='+ this.state.tankData.description4 +'&name5='+ this.state.tankData.sensors5 +'&value5='+ this.state.tankData.feetLevel5 +'&typ5='+ this.state.tankData.description5 +'&name6=Start&value6=0&typ6=High&sensortype='+ this.state.tankData.propertyId} width="335" height="315" frameBorder="0" scrolling="no"></iframe>
					</div>
				</div>
			</div>
			
			  <div style={{ marginTop: "10px" }}>
				
				<MUIDataTable
				  title={"IoT List"}
				  data={dataArr}
				  columns={columns}
				  options={options} />

			  </div>
			</>
		  );
		}
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(TankView)
